import 'css-chunksrc/client/scenes/optimizedGantt/calendar/styles.scss';export default {
  "calendar": "_calendar_1nq75_1",
  "dates": "_dates_1nq75_10",
  "date": "_date_1nq75_10",
  "header": "_header_1nq75_28",
  "restDay": "_restDay_1nq75_36",
  "heading": "_heading_1nq75_40",
  "lastRestDay": "_lastRestDay_1nq75_44",
  "weeklyName": "_weeklyName_1nq75_63",
  "daily": "_daily_1nq75_67",
  "dayName": "_dayName_1nq75_77",
  "hours": "_hours_1nq75_82",
  "hour": "_hour_1nq75_82",
  "hourLabel": "_hourLabel_1nq75_97",
  "now": "_now_1nq75_106",
  "monthly": "_monthly_1nq75_120",
  "lastMonthDay": "_lastMonthDay_1nq75_127",
  "weekEndDay": "_weekEndDay_1nq75_130",
  "yearly": "_yearly_1nq75_134",
  "lastYearDay": "_lastYearDay_1nq75_144"
};